// extracted by mini-css-extract-plugin
module.exports = {"ListPolls":"ListPolls_ListPolls__hzYbL","header":"ListPolls_header__dRlIs","view":"ListPolls_view__fe-2g","cards":"ListPolls_cards__3RBZB"};